import { Component } from '@angular/core'
import { Subject } from 'rxjs/internal/Subject'
import { LoaderService } from '../../services/loader.service'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'app-loader',
    imports: [CommonModule],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  isLoading: Subject<boolean> = this.loaderService.isLoading
  constructor (private readonly loaderService: LoaderService) { }
}
